import React from 'react';
import fetch from 'isomorphic-unfetch';

import { initializeStore } from '../redux/store';
import { getNav, getSocialIcons, getFooter } from './sanityApi';

const navConfig = require('../userNav.json');

const isServer = typeof window === 'undefined';
const __NEXT_REDUX_STORE__ = '__NEXT_REDUX_STORE__';

function getOrCreateStore(initialState) {
  // Always make a new store if server, otherwise state is shared between requests
  if (isServer) {
    return initializeStore(initialState);
  }

  // Create store if unavailable on the client and set it on the window object
  if (!window[__NEXT_REDUX_STORE__]) {
    window[__NEXT_REDUX_STORE__] = initializeStore(initialState);
  }
  return window[__NEXT_REDUX_STORE__];
}

export default (App) => class AppWithRedux extends React.Component {
  static async getInitialProps(appContext) {
    const nav = await getNav(false);
    const socialIcons = await getSocialIcons(false);
    const footer = await getFooter(false);

    const initialState = {
      main: {
        userType: false,
        redirect: '',
        highered: false,
        googleAnaltyicsId: '',
        gtmId: '',
        sanityData: '',
        captchaSiteKey: '',
        captchaSiteTestKey: '',
      },
    };

    if (appContext.ctx.req) {
      if (appContext.ctx.req.staticData) {
        initialState.main.googleAnaltyicsId = appContext.ctx.req.staticData.googleAnaltyicsId;
        initialState.main.gtmId = appContext.ctx.req.staticData.gtmId;
      }

      if (appContext.ctx.req.query.redirect) {
        initialState.main.redirect = appContext.ctx.req.query.redirect;
      }

      if (appContext.ctx.req.query.userType) {
        initialState.main.userType = appContext.ctx.req.query.userType;
      }

      if (appContext.ctx.req.query.highered) {
        const baseUri = navConfig.LOCAL_COM || navConfig.COM;
        const higheredData = await fetch(`${baseUri}/api/highered?slug=${appContext.ctx.req.query.highered}`).then((data) => data.json());

        if (higheredData.total === 1) {
          const [data] = higheredData.data;
          initialState.main.highered = data;
        } else {
          initialState.main.highered = false;
        }
      }

      initialState.main.sanityData = { nav, socialIcons, footer };

    }

    // Get or Create the store with `undefined` as initialState
    // This allows you to set a custom default initialState
    const reduxStore = getOrCreateStore(initialState);

    // Provide the store to getInitialProps of pages
    appContext.ctx.reduxStore = reduxStore;

    let appProps = {};
    if (typeof App.getInitialProps === 'function') {
      appProps = await App.getInitialProps(appContext);
    }

    return {
      ...appProps,
      initialReduxState: reduxStore.getState(),
      env: {
        GA_ANALYTICS_ID: process.env.GA_ANALYTICS_ID,
        GTM_ID: process.env.GTM_ID,
      },
    };
  }

  constructor(props) {
    super(props);
    this.reduxStore = getOrCreateStore(props.initialReduxState);
  }

  render() {
    return <App {...this.props} reduxStore={this.reduxStore} />;
  }
};
